import techImg from "../assets/category-technology-re.webp";
import healthImg from "../assets/category-health-re.webp";
import businessImg from "../assets/category-business-re.webp";
import artImg from "../assets/category-art-re.webp";
import natureImg from "../assets/category-nature-re.webp";
import lifestyleImg from "../assets/category-lifestyle-re.webp";
import otherImg from "../assets/category-other-re.webp";

export const categories = [
  {
    name: "Technology",
    image: techImg,
  },
  {
    name: "Health & Wellness",
    image: healthImg,
  },
  {
    name: "Business & Finance",
    image: businessImg,
  },
  {
    name: "Arts & Entertainment",
    image: artImg,
  },
  {
    name: "Science & Nature",
    image: natureImg,
  },
  {
    name: "Lifestyle & Travel",
    image: lifestyleImg,
  },
  {
    name: "other",
    image: otherImg,
  },
];
